export default "__VITE_ASSET__DmjJ$b7M__"